<div class="errwrap">
  <div class="errdiv1" id="ErrorDiv"></div>
</div>
<div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title">{{ screentitle }}</h1>
      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="btn back-button button-margin">
          <button class="btn btn-primary commonbutt" type="button" (click)="submitdata()" [disabled]="showList == true">
            <em class="fa fa-check"></em>&nbsp;Submit
          </button>
          <button class="btn btn-success commonbutt" *ngIf="!showList == false && RAC_APROVE == '1'" type="button"
            [disabled]="showList == false" data-toggle="modal" data-target="#myModal">
            <em class="fa fa-thumbs-up "></em>&nbsp;&nbsp;
            <span class="bold">Approve</span>
          </button>
          <button class="btn btn-warning commonbutt" *ngIf="!showList == false && RAC_APROVE == '1'" type="button"
            [disabled]="showList == false" data-toggle="modal" data-target="#myModal2">
            <em class="fa fa-thumbs-down"></em> <span class="bold">Reject</span>
          </button>
          <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div style="padding: 2% 4% 2% 2%">
                  <div>
                    <div class="col-lg-3">
                      <label>Role Name</label>
                      <input type="text" class="form-control" id="ROLE_NAME" name="ROLE_NAME"
                        placeholder="Enter Role Name" [(ngModel)]="role_screen_details.ROLE_NAME" #ROLE_NAME="ngModel"
                        [disabled]="showList == true" (input)="checkLength($event.target.value, 1)"
                        (blur)="checkAvailable()" />
                      <span id="rolenameErr"></span>
                    </div>
                    <div class="col-lg-3">
                      <label>Role Description</label>
                      <input type="text" class="form-control" id="ROLE_DESCRIPTION" name="ROLE_DESCRIPTION"
                        placeholder="Enter description " [(ngModel)]="role_screen_details.ROLE_DESCRIPTION"
                        #ROLE_DESCRIPTION="ngModel" [disabled]="showList == true" />
                    </div>
                    <div class="clr"></div>

                    <div class="row " style="font-weight: bold;margin-top: 15px">
                      <div id="dataErr"></div>
                    </div>
                    <div class="row " id="ul" *ngFor="let check of checkbox_details; let i = index"
                      style="font-size: 15px;">

                      <div class="form-group funTabs col-lg-3">
                        <span><input type="checkbox" [checked]="check.status" [value]="check.FUN_ID"
                            *ngIf="check.FUN_ROUTER_NAME != ''" id="fun{{ check.FUN_ID }}" (change)="
                              checkCheckBox(
                                $event,
                                check.FUN_ID,
                                check.FUN_PARENT
                              )
                            " [disabled]="showList == true" />
                        </span>
                        <span *ngIf="check.FUN_ROUTER_NAME == ''" class="mainTab maintab_maindiv">
                          <div class="row ">
                            <div class=" col-lg-3">{{ check.FUN_NAME }}</div>
                            <div class=" col-lg-2">View</div>
                            <div class=" col-lg-2 mainTabs">Add</div>
                            <div class=" col-lg-2 mainTabs">Edit</div>
                            <div class=" col-lg-2">Aprove/Reject</div>
                          </div>
                        </span>
                        <span class="smallTav" *ngIf="check.FUN_ROUTER_NAME != ''">
                          {{ check.FUN_NAME }}
                        </span>
                      </div>
                      <div class="form-group funTabs col-lg-2">
                        <input type="checkbox" [checked]="check.status2" disabled id="view{{ check.FUN_ID }}"
                          *ngIf="check.FUN_ROUTER_NAME != ''" (change)="
                            checkBoxAdd($event, i, 'VIEW', check.FUN_ID)
                          " [disabled]="showList == true" />
                      </div>
                      <div class="form-group funTabs col-lg-2">
                        <input type="checkbox" [checked]="check.status3" disabled id="add{{ check.FUN_ID }}"
                          *ngIf="check.FUN_ROUTER_NAME != ''" (change)="checkBoxAdd($event, i, 'ADD', check.FUN_ID)"
                          [disabled]="showList == true" />
                      </div>

                      <div class="form-group funTabs col-lg-2">
                        <input type="checkbox" [checked]="check.status4" disabled id="edit{{ check.FUN_ID }}"
                          *ngIf="check.FUN_ROUTER_NAME != ''" (change)="
                            checkBoxAdd($event, i, 'EDIT', check.FUN_ID)
                          " [disabled]="showList == true" />
                      </div>
                      <div class="form-group funTabs col-lg-2">
                        <input type="checkbox" [checked]="check.status5" disabled id="aprove{{ check.FUN_ID }}"
                          *ngIf="check.FUN_ROUTER_NAME != ''" (change)="
                            checkBoxAdd($event, i, 'APRREJ', check.FUN_ID)
                          " [disabled]="showList == true" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- portlet  -->
            </div>
          </div>
          <!-- form ends  -->
        </div>
      </div>
      <!-- ends  -->
    </div>
  </div>
</div>

<div class="modal fade" id="myModal" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 50px;">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title"><span class="glyphicon glyphicon-thumbs-up"></span>Approve Request</h4>
      </div>
      <div class="modal-body">
        <div class="col-lg-13">
          <label> Remarks</label>
          <textarea 
            [(ngModel)]="aprove_details.APPROVAL_REMARKS" 
            rows="8" cols="20" type="text"
            class="form-control m-input" placeholder="Enter  Remarks">
          </textarea>
          <span 
          *ngIf="aprove_details.APPROVAL_REMARKS == ''" 
          class="m-form__help" style="color: red">Please enter
            Remarks</span>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-success " type="button" 
        (click)="aproveReject(1)"
         data-dismiss="modal">
          <em class="fa fa-check "></em>&nbsp;&nbsp;
          <span class="bold">Approve</span>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- ########## -->

<!-- ########## -->
<div class="modal fade" id="myModal2" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 50px;">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title"><span class="glyphicon glyphicon-thumbs-down"></span>Reject Request</h4>
      </div>
      <div class="modal-body">
        <div class="col-lg-13">
          <label>Remarks</label>
          <textarea 
          [(ngModel)]="aprove_details.APPROVAL_REMARKS" 
          rows="8" cols="20" type="text"
            class="form-control m-input"
             placeholder="Enter  Remarks">
          </textarea>
          <span 
          *ngIf="aprove_details.APPROVAL_REMARKS == ''" 
          class="m-form__help" style="color: red">Please enter
            Remarks</span>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-warning " type="button" 
        (click)="aproveReject(2)" data-dismiss="modal">
          <em class="fa fa-check "></em>&nbsp;&nbsp;
          <span class="bold">Reject</span>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- ########## -->

<div 
*ngIf="actionmode != 'Add' && actionmode != 'Edit'" class="searchdiv">
  <div class="headerdiv">
    <h1>Role Management Search</h1>
    <div class="bothbuttdiv">
      <button class="btn btn-primary commonbutt" *ngIf="RAC_ADD == '1'" type="button" (click)="addForm()">
        <em class="fa fa-plus-circle"></em>&nbsp;Add New
      </button>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div class="row">
            <div class="m-portlet">
              <div>
                <div>
                  <div class="wr15">
                    <div class="instruct">
                      <div class="int1" style="margin-left: 17px">
                        <span class="inst" style="font-size: 12px"><strong> Instructions </strong></span>
                        <br />

                        <span class="txt">
                          1. Select at least one value out of Role Name,Role
                          Description
                        </span>
                        <br />
                        <span class="txt">
                          2. You can also use a combination of the given fields
                          to search
                        </span>
                        <br />
                        <span></span>
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <label>Role Name:</label>
                      <input type="text" class="form-control" id="ROLE_NAME" name="ROLE_NAME"
                        placeholder="Enter Role Name" [(ngModel)]="role_search_details.ROLE_NAME" #ROLE_NAME="ngModel"
                        (input)="checkLength($event.target.value, 2)" />
                      <span id="rolenameSearchErr"></span>
                    </div>
                    <div class="col-lg-3">
                      <label class="">Role Description:</label>
                      <input type="text" class="form-control" id="ROLE_DESCRIPTION" name="ROLE_DESCRIPTION"
                        placeholder="Enter description " [(ngModel)]="role_search_details.ROLE_DESCRIPTION"
                        #ROLE_DESCRIPTION="ngModel" />
                    </div>
                  </div>
                </div>
                <div class="btn clear-button button-margin">
                  <button class="btn btn-primary commonbutt" (click)="searchData()" style="float: right;  margin-top: 0px;
                    " type="button" [disabled]="lengthCheck == true">
                    <em class="fa fa-search "></em>&nbsp;Search
                  </button>
                </div>
              </div>
              <div style="padding: 2% 2% 2% 2%" [hidden]="searchlist" *ngIf="serachtabledata != ''">
                <table aria-describedby="userRoleMasterDetails" class="table table-striped" *ngIf="!loader"
                  [mfData]="serachtabledata" [mfRowsOnPage]="5">
                  <thead>
                    <tr>
                      <th scope="col" style="width: 10%" *ngIf="RAC_VIEW == '1' || RAC_EDIT == '1'">
                        Actions
                      </th>
                      <th scope="col" style="width: 20%">
                        <mfDefaultSorter by="name">Role Name</mfDefaultSorter>
                      </th>
                      <th scope="col" style="width: 50%">
                        <mfDefaultSorter by="email">Role Description</mfDefaultSorter>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="
                        let item of (serachtabledata
                          | paginate: { itemsPerPage: 10, currentPage: p })
                      ">
                      <td *ngIf="RAC_VIEW == '1' || RAC_EDIT == '1'">
                        <button class="btn btn-default btn-circle" *ngIf="RAC_VIEW == '1'" type="button"
                          (click)="showFormData(item.ROLE_ID, 1)">
                          <em class="fa fa-eye"></em>
                        </button>
                        <button class="btn btn-default btn-circle" *ngIf="RAC_EDIT == '1'" type="button"
                          (click)="showFormData(item.ROLE_ID, 2)">
                          <em class="fa fa-pencil"></em>
                        </button>
                      </td>
                      <td>{{ item.ROLE_NAME | uppercase }}</td>
                      <td>{{ item.ROLE_DESCRIPTION }}</td>
                    </tr>
                  </tbody>
                  <pagination-controls (pageChange)="p = $event"></pagination-controls>
                  <tfoot>
                    <tr></tr>
                  </tfoot>
                </table>
              </div>
              <div *ngIf="loader">
                <div style="margin:auto; text-align: center">
                  <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>